import { render, staticRenderFns } from "./GenexDisableableTooltip.vue?vue&type=template&id=2815cfb8&scoped=true&"
import script from "./GenexDisableableTooltip.vue?vue&type=script&lang=js&"
export * from "./GenexDisableableTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815cfb8",
  null
  
)

export default component.exports